var I = /* @__PURE__ */ ((r) => (r.X = "x", r.Y = "y", r.Z = "z", r.VISIBILITY = "visibility", r.SECTION = "section", r.RESET = "reset", r))(I || {});
export {
  I as PlaneAction
};
//# sourceMappingURL=HoopsViewerToolbar.types.mjs.map
